import React from 'react';
import { Box, Typography } from '@mui/material';
import CodeChip from './CodeChip';

// The codes a coder can pick on one dimension (Figma "Code picker"). `codes` comes from the
// codebook (codes.js): UT for the target's speaker, or the 5 RC classes. Nothing is pre-selected;
// clicking the selected code again leaves it selected (a pick is changed, never cleared).
// `stacked` puts the label above the chips, as on the item screen; otherwise it sits to the left.
const CodePicker = ({ label, codes, value, onChange, disabled = false, id, stacked = false, hint }) => (
    <Box sx={stacked ? {} : { display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Typography
            id={id}
            component="span"
            variant={stacked ? 'subtitle2' : 'overline'}
            sx={stacked
                ? { display: 'block', mb: 1, fontSize: '0.875rem', color: 'text.primary' }
                : { color: 'text.secondary', width: 28, flexShrink: 0, lineHeight: 1 }}
        >
            {label}
        </Typography>
        <Box role="radiogroup" aria-labelledby={id} sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap' }}>
            {codes.map((entry) => (
                <CodeChip
                    key={entry.code}
                    code={entry.code}
                    title={entry.name}
                    aria-label={`${entry.code}, ${entry.name}`}
                    selected={value === entry.code}
                    disabled={disabled}
                    onClick={() => onChange(entry.code)}
                />
            ))}
        </Box>
        {hint && (
            <Typography variant="caption" component="p" color="text.secondary" sx={{ mt: 0.75 }}>{hint}</Typography>
        )}
    </Box>
);

export default CodePicker;
